//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import moment from 'moment-timezone';
import { DateUtils } from 'unison';

import { IUnisonDateRange } from '@models/UnisonTypes';

export const minDateToDateRangeObj = (minDate: Date): IUnisonDateRange => {
  let startDate = moment(minDate).add(1, 'd').startOf('day');
  let endDate = moment().startOf('day');

  if (startDate.isAfter(endDate)) {
    startDate = endDate;
    endDate = endDate.endOf('day');
  }

  return {
    alias: 'custom',
    startDate: startDate.toDate(),
    endDate: endDate.toDate(),
  };
};

export const getMinDateRangeDate = (minDate: Date): Date => {
  const minMoment = moment(minDate);

  if (minMoment.isSame(moment(), 'day')) {
    return minMoment.startOf('day').toDate();
  } else {
    return minMoment.endOf('day').toDate();
  }
};

/** Gets a min date range alternative for last 7 days if minDate is less than 7 days ago */
export const getDateRangeDefault = (minDate: Date): IUnisonDateRange => {
  const last7DaysRange = DateUtils.getDateRangeFromAlias('last7Days');
  if (moment(last7DaysRange.startDate).isBefore(moment(minDate))) {
    return minDateToDateRangeObj(minDate);
  } else {
    return last7DaysRange;
  }
};
